module.exports = __webpack_public_path__ + "img/dice-yxx3-4.4fba02b7.svg";